<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 用户地址管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-form :model="query" ref="query" label-width="80px" inline="">
                    <el-form-item label="用户姓名:" label-width="75px">
                        <el-input v-model="query.name" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号:" label-width="75px">
                        <el-input v-model="query.phone" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getData()">搜索</el-button>
                    <el-button type="primary"  @click="resetsearch()">重置</el-button>
                </el-form>
            </div>
              <div class="next-box">
                <el-button
                    type="danger"
                    icon="el-icon-delete-solid"
                    @click="delAllSelection"
                >批量删除</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >   
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="name" label="姓名"  align="center"></el-table-column>
                <el-table-column prop="phone" label="手机号"  align="center"></el-table-column>
                <el-table-column prop="region" label="地区"  align="center"></el-table-column>
                <el-table-column prop="address" label="详细地址"  align="center"></el-table-column>
                <el-table-column prop="postcode" label="邮编"  align="center"></el-table-column>
                <el-table-column prop="status" label="状态"  align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0">非默认地址</span>
                        <span v-if="scope.row.status == 1">默认地址</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="300" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>  
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="编辑用户地址" :visible.sync="editVisible" width="500px">
            <el-form ref="editForm" :rules="rules" :model="editForm" label-width="100px" >
                 <el-form-item label="姓名" prop="name">
                    <el-input v-model="editForm.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="editForm.phone"></el-input>
                </el-form-item>
                <el-form-item label="地址" prop="address">
                    <el-input v-model="editForm.address"></el-input>
                </el-form-item>
                <el-form-item label="省" prop="province"  >
                    <el-select v-model="editForm.province"  style="width:180px" @change="findcity()" filterable>
                        <el-option
                            v-for="item in options"
                            :key="item.label"
                            :label="item.label"
                            :value="item.label"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  label="市" prop="city" >
                    <el-select v-model="editForm.city"  style="width:190px" filterable @change="findcity()">
                        <el-option
                            v-for="item in options[cityindex].children"
                            :key="item.label"
                            :label="item.label"
                            :value="item.label"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  label="区" prop="area" >
                    <el-select v-model="editForm.area"  style="width:190px" filterable>
                        <el-option
                                v-for="item in options[cityindex].children[areaindex].children"
                                :key="item.label"
                                :label="item.label"
                                :value="item.label"
                            >
                        </el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="邮编" prop="postcode">
                    <el-input v-model="editForm.postcode"></el-input>
                </el-form-item>
            </el-form>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>


import { post } from '../../../api/request';
import { regionData } from 'element-china-area-data'
export default {
    name: 'basetable',
    data() {
        return {
            cityindex:0,
            areaindex:0,
            options: regionData,
            companyid:'',//当前公司id
            //搜索数据
            tableData: [],
            query: {
                name:'',
                phone: '',
                pageIndex: 1,
                pageSize: 8
            },
            pageTotal: 7,
            //添加数据
            addVisiable:false,
            addForm:{
               type:'',
            },
            //编辑数据
            editVisible:false,
            editForm:{},
            //添加数据表单验证
            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                ],
                address: [
                    { required: true, message: '请输入地址', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                ],
                postcode: [
                    { required: true, message: '请输入邮编', trigger: 'blur' },
                ],
                province: [
                    { required: true, message: '请选择省份', trigger: 'blur' },
                ],
                area: [
                    { required: true, message: '请选择市区', trigger: 'blur' },
                ],
                city: [
                    { required: true, message: '请选择县区', trigger: 'blur' },
                ],
               
            },
            //批量删除
            multipleSelection: [],
            delList: [],
            //获取id
            idx: -1,
            id: -1
        };
    },
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
    },
    methods: {
        findcity(){
            for(let i = 0;i<this.options.length;i++)
            {
                if(this.editForm.province == this.options[i].label)
                {
                    this.cityindex = i
                }
            }
            for(let i = 0;i<this.options[this.cityindex].children.length;i++){
                if(this.editForm.city == this.options[this.cityindex].children[i].label)
                {
                    this.areaindex = i
                }
            }
        },
        //重置搜索
        resetsearch(){
            this.query.name= '',
            this.query.phone= '',
            this.query.pageIndex = 1
            this.getData()
        },
        // 获取后端接口数据
        getData() {
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('name',this.query.name)
            formdata.append('phone',this.query.phone)
            formdata.append('page',this.query.pageIndex)
            formdata.append('limit',this.query.pageSize)
            post('admin/address/chackAddress2',formdata).then(res => {
                if(res.code=200){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                    if (!this.tableData.length && this.query.pageIndex > 1) {
                        this.query.pageIndex--;
                        this.getData()
                     }  
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        // 触发搜索按钮
        inputSearch(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('name',this.query.name)
            formdata.append('phone',this.query.phone)
            formdata.append('page',1)
            formdata.append('limit',this.query.pageSize)
            post('admin/address/chackAddress2',formdata).then(res => {
                if(res.data.data){
                    this.tableData = res.data.data.list
                    this.pageTotal = res.data.data.num
                }
            });
        },
        handleEdit(index, row) {
            this.idx = index;
            this.editForm = Object.assign({}, row);
            this.editVisible = true;
            this.editForm.employ_id ="暂无"
           
        },
        // 分配员工保存编辑
        saveEdit() {
            console.log(this.editForm.employ_id)
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    let formdata = new FormData()
                    this.editForm.region =this.editForm.province+this.editForm.area+this.editForm.city
                    formdata.append('id',this.editForm.id)
                    formdata.append('address',this.editForm.address)
                    formdata.append('area',this.editForm.area)
                    formdata.append('city',this.editForm.city)
                    formdata.append('company_id',this.editForm.company_id)
                    formdata.append('employ_id',this.editForm.employ_id)
                    formdata.append('name',this.editForm.name)
                    formdata.append('openid',this.editForm.openid)
                    formdata.append('address',this.editForm.address)
                    formdata.append('phone',this.editForm.phone)
                    formdata.append('postcode',this.editForm.postcode)
                    formdata.append('province',this.editForm.province)
                    formdata.append('region',this.editForm.region)
                    formdata.append('status',this.editForm.status)
                    post('admin/address/updaAddress',formdata).then(res=>{
                        if(res.data.msg == "修改成功"){
                            this.getData()
                            this.$message.success('修改成功')
                            this.editVisible = false
                        }
                      
                        else{
                            this.$message.error('修改失败')
                        }
                    
                    })
                }
            })
        },
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let formdata = new FormData()
                    formdata.append('id',row.id)
                    post('admin/address/deleAddress',formdata).then(res=>{
                        if(res.data.msg=="删除成功"){
                            this.$message.success('删除成功');
                            this.getData()
                        }
                        else
                            this.message.error('删除失败')
                    })
                })
                .catch(() => {});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
         // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].id + ',';
            }
            let formdata = new FormData()
            formdata.append('id',str)
            post('admin/address/alldeAddress',formdata).then(res=>{
                if(res.data.msg == "删除成功"){
                    this.multipleSelection = [];
                    this.$message.success('删除成功')
                    this.getData()
                }
                else{
                    this.$message.error('删除失败')
                }
            })
        },
    }
};
</script>

<style scoped>

.next-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.editor-btn{
    margin-top: 20px;
}
</style>
